import React from 'react';

type ContextType = {
    isNewTable: boolean;
    setIsNewTable: (isNewTable: boolean) => void;
};
const initialContext = {
    isNewTable: false,
    setIsNewTable: () => {},
};

const NewTableContext = React.createContext<ContextType>(initialContext);
export default NewTableContext;
